import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export function usePageLoading() {
  const [isLoading, setIsLoading] = useState(false);
  const [isRouteChanging, setIsRouteChanging] = useState(false);
  const location = useLocation();

  // Loading para mudanças de rota
  useEffect(() => {
    setIsRouteChanging(true);
    
    const timer = setTimeout(() => {
      setIsRouteChanging(false);
    }, 600); // 600ms de transição para ver melhor o efeito circular

    return () => clearTimeout(timer);
  }, [location.pathname]);

  // Loading inicial da página
  useEffect(() => {
    setIsLoading(true);
    
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 1200); // 1.2s para carregamento inicial

    return () => clearTimeout(timer);
  }, []);

  return {
    isLoading,
    isRouteChanging,
    setIsLoading,
    setIsRouteChanging
  };
} 